import React from "react";
import Img404 from "./images/internet.svg";
import { Box, Typography } from "@mui/material";

function NoMatch() {
	return (
		<Box
			display={"flex"}
			justifyContent={"center"}
			alignItems={"center"}
			flexDirection={"column"}
			width={"100%"}
			height={"70vh"}>
			<img
				alt="noMatchImage"
				src={Img404}
				loading="lazy"
				width={300}
				height={300}
			/>
			<Typography
				component={"h1"}
				sx={{ color: "white", fontSize: "25px" }}
				textAlign="center">
				صفحه مورد نظر یافت نشد!
			</Typography>
		</Box>
	);
}

export default NoMatch;
